import React from "react";
import { AlertTriangle, Plus, RotateCw } from "lucide-react";

// Pure presentational — CreateBehavioralSet.jsx stays the single owner of draft
// mutation (same pattern as every other edit path there), this just renders the
// state and forwards clicks.
const PartialFailureBanner = ({ failedCompetencies, retryingId, onRetry, onAddManually }) => {
  if (!failedCompetencies?.length) return null;

  return (
    <div className="mx-6 lg:mx-12 mb-2 rounded-xl border border-amber-400/30 bg-amber-500/10 px-4 py-3 space-y-2">
      <div className="flex items-start gap-2.5 text-amber-400">
        <AlertTriangle size={14} className="shrink-0 mt-0.5" />
        <div className="text-sm leading-relaxed">
          <p className="font-medium">
            {failedCompetencies.length === 1
              ? "1 competency didn't generate"
              : `${failedCompetencies.length} competencies didn't generate`}
          </p>
          <p className="text-amber-400/80 font-normal mt-0.5">
            Everything else generated fine — retry just the ones below, or add questions for them manually.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 pl-6">
        {failedCompetencies.map((f) => (
          <div
            key={f.competency_id}
            className="flex items-center gap-2 rounded-full border border-amber-400/30 bg-bgPrimary dark:glass-effect px-3 py-1.5 text-xs"
          >
            <span className="dark:text-gray-200 text-textPrimary font-medium">{f.competency_name}</span>
            <button
              type="button"
              onClick={() => onRetry(f.competency_id)}
              disabled={retryingId === f.competency_id}
              className="flex items-center gap-1 text-blue-400 hover:text-blue-300 transition-colors disabled:opacity-50"
            >
              <RotateCw size={11} className={retryingId === f.competency_id ? "animate-spin" : ""} />
              Retry
            </button>
            <button
              type="button"
              onClick={() => onAddManually(f.competency_id)}
              className="flex items-center gap-1 dark:text-gray-400 text-textSecondary hover:text-textPrimary transition-colors"
            >
              <Plus size={11} /> Add manually
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartialFailureBanner;
